import { Box, type BoxProps } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { m } from 'framer-motion';
import { useMemo } from 'react';
import { FullScreenBox } from '../full-screen-box';
import { Logo } from '../logo';
import * as SX from './sx';

export const SplashScreen = ({
  sx,
  from,
  logoSrc,
  ...other
}: BoxProps & { from?: string; logoSrc?: string }) => {
  const children = useMemo(
    () => (
      <>
        <m.div
          animate={{
            scale: [1, 0.9, 0.9, 1, 1],
            opacity: [1, 0.48, 0.48, 1, 1],
          }}
          transition={{
            duration: 2,
            ease: 'easeInOut',
            repeatDelay: 1,
            repeat: Infinity,
          }}
        >
          <Logo disabledLink src={logoSrc} sx={SX.logo} />
        </m.div>
        <Box
          component={m.div}
          animate={{
            scale: [1.6, 1, 1, 1.6, 1.6],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          sx={{
            width: 100,
            height: 100,
            position: 'absolute',
            border: (theme) => `solid 3px ${alpha('#0A2D8F', 0.24)}`,
          }}
        />

        <Box
          component={m.div}
          animate={{
            scale: [1, 1.2, 1.2, 1, 1],
            rotate: [0, 270, 270, 0, 0],
            opacity: [1, 0.25, 0.25, 0.25, 1],
            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
          }}
          transition={{
            ease: 'linear',
            duration: 3.2,
            repeat: Infinity,
          }}
          sx={{
            width: 120,
            height: 120,
            position: 'absolute',
            border: (theme) => `solid 8px ${alpha('#0A2D8F', 0.24)}`,
          }}
        />
      </>
    ),
    [logoSrc]
  );

  return (
    <FullScreenBox className="SplashScreen" sx={sx} {...other} onTop>
      {children}
    </FullScreenBox>
  );
};
